import { cn } from '@/utils/styles';

import { ConnectionIcon } from '@/components/icons/ConnectionIcon';
import { formatConnectionLabel } from '@/utils/health/formatConnectionLabel';

interface ConnectionCardProps {
  name: string;
  noOfConnections: number | null;
  connectionType: string;
  connectionTypeColor: string;
  isProUser?: boolean;
  onClick?: () => void;
  'data-testid'?: string;
}

export const ConnectionCard: React.FC<ConnectionCardProps> = ({
  name,
  noOfConnections,
  connectionType,
  connectionTypeColor,
  isProUser,
  onClick,
  'data-testid': testId,
}) => {

  const connectionData = formatConnectionLabel(noOfConnections, isProUser);

  return (
    <button
      onClick={onClick}
      className={cn(
        'p-5 rounded-lg  shadow-md bg-[#42434D73] hover:shadow-lg transition-shadow text-left w-full',
      )}
      data-testid={testId}
    >
      <div data-testid="connectionCard-content">
        <div className="flex justify-between w-full" data-testid="connectionCard-header">
          {/* Connection Type */}
          <div className='w-3/5 flex justify-start mr-3' data-testid="connectionCard-typeContainer">
            <div
              className={cn('dark inline-block px-2 py-1 rounded bg-black')}
              style={{
                color: connectionTypeColor
              }}
              data-testid="connectionCard-typeBadge"
            >
              <p className="typography-caption1 line-clamp-1" data-testid="connectionCard-typeText">
                <abbr className="no-underline" title={connectionType}>
                  {connectionType}
                </abbr>
              </p>
            </div>
          </div>

          <div className="flex w-2/5 justify-end items-center" data-testid="connectionCard-statsContainer">
            {!isProUser && (
              <>
                <p className="typography-body text-secondary mr-1 whitespace-nowrap min-w-16 truncate" data-testid="connectionCard-connectionCount">
                  <abbr className="no-underline" title={connectionData}>
                    {connectionData}
                  </abbr>
                </p>
                <ConnectionIcon className="!size-6" data-testid="connectionCard-icon" />
              </>
            )}
          </div>
        </div>
        <h3
          className={cn(
            'dark typography-title text-primary truncate whitespace-nowrap',
            isProUser ? 'mt-2' : 'mt-4',
          )}
          title={name}
          data-testid="connectionCard-name"
        >
          {name}
        </h3>
        {isProUser && (
          <div className="flex justify-end items-center gap-1 mt-1" data-testid="connectionCard-connectionCountBottom">
            <p className="typography-caption1 text-secondary">
              {connectionData}
            </p>
            <ConnectionIcon className="!size-6" data-testid="connectionCard-iconBottom" />
          </div>
        )}
      </div>
    </button>
  );
};
